import React from 'react';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';
import * as LocalizationUtil from '@vp-dst/localization-util';

import { colors, defaultTextStyle } from 'settings/theme';

import Star from 'components/icons/Star';

function getTextByStarNumber(starNumber) {
  switch (starNumber) {
    case 1:
      return LocalizationUtil.getLocalizedText('i-really-dont-like-it');
    case 2:
      return LocalizationUtil.getLocalizedText('i-dont-like-it');
    case 3:
      return LocalizationUtil.getLocalizedText('its-okay');
    case 4:
      return LocalizationUtil.getLocalizedText('i-love-it');
    case 5:
      return LocalizationUtil.getLocalizedText('i-really-love-it');
    default:
      throw new Error(`Unexpected star number: ${starNumber}`);
  }
}

class RatingBox extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hovering: false,
      hoveredStarNumber: null,
      selectedStarNumber: 5,
    };

    this.starsOnMouseEnter = this.starsOnMouseEnter.bind(this);
    this.starsOnMouseLeave = this.starsOnMouseLeave.bind(this);
    this.starOnMouseEnter = this.starOnMouseEnter.bind(this);
    this.starOnClick = this.starOnClick.bind(this);
  }

  starsOnMouseEnter() {
    const { interactive } = this.props;

    if (interactive) {
      this.setState({
        hovering: true,
      });
    }
  }

  starsOnMouseLeave() {
    const { interactive } = this.props;

    if (interactive) {
      this.setState({
        hovering: false,
        hoveredStarNumber: null,
      });
    }
  }

  starOnMouseEnter(starNumber) {
    const { interactive } = this.props;

    if (interactive) {
      this.setState({
        hoveredStarNumber: starNumber,
      });
    }
  }

  starOnClick(starNumber) {
    const { interactive } = this.props;

    if (interactive) {
      this.setState({
        selectedStarNumber: starNumber,
      });
    }
  }

  render() {
    const {
      style,
    } = this.props;

    const {
      hovering,
      hoveredStarNumber,
      selectedStarNumber,
    } = this.state;

    const maxHighlightedStar = hovering ? hoveredStarNumber || selectedStarNumber : selectedStarNumber;

    return (
      <div style={style}>
        <div
          style={{
            ...defaultTextStyle,
            textAlign: 'center',

            position: 'relative', // so that submit-button can be absolutely positioned

            boxSizing: 'border-box',
            height: 255,
            width: 300,
            paddingTop: 30,
            paddingLeft: 30,
            paddingRight: 30,

            border: `1px solid ${colors.border}`,
            borderRadius: 12,
            backgroundColor: 'white',

            overflow: 'hidden',
          }}
        >
          <div
            style={{
              fontWeight: 'bold',
              fontSize: '1.5em',

              marginBottom: 20,
            }}
          >
            {LocalizationUtil.getLocalizedText('rate-your-experience')}
          </div>
          <div
            style={{
              fontSize: '1.2em',

              marginBottom: 10,
            }}
          >
            {LocalizationUtil.getLocalizedText('tell-us-how-we-did')}
          </div>
          <div
            style={{
              marginBottom: 10,
            }}
            onMouseEnter={this.starsOnMouseEnter}
            onMouseLeave={this.starsOnMouseLeave}
          >
            {[1, 2, 3, 4, 5].map(starNumber => (
              <button
                type="button"
                key={`star-${starNumber}`}
                style={{
                  padding: 0,
                  backgroundColor: 'unset',
                  border: 'none',

                  marginRight: 10,
                }}
                onClick={() => this.starOnClick(starNumber)}
                onMouseEnter={() => this.starOnMouseEnter(starNumber)}
              >
                <Star
                  color={starNumber <= maxHighlightedStar ? colors.blueMid : colors.disabled}
                  size={30}
                />
              </button>
            ))}
          </div>
          <div
            style={{
              fontWeight: 'bold',
              fontSize: '1.3em',
            }}
          >
            {getTextByStarNumber(maxHighlightedStar)}
          </div>
          <div
            style={{
              position: 'absolute',
              bottom: 0,
              left: '50%',
              transform: 'translateX(-50%)',

              height: 40,
              width: '100%',

              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',

              backgroundColor: colors.blueMid,
              color: 'white',
              fontWeight: 'bold',
              fontSize: '1.3em',
            }}
          >
            {LocalizationUtil.getLocalizedText('submit')}
          </div>
        </div>
      </div>
    );
  }
}

RatingBox.propTypes = {
  interactive: PropTypes.bool,
  style: StylePropType,
};

RatingBox.defaultProps = {
  interactive: false,
  style: {},
};

export default RatingBox;



// WEBPACK FOOTER //
// ./src/components/RatingBox.js